module.exports = __webpack_public_path__ + "img/logo.43b84352.jpg";